import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import {
  apiDataResponseMapper,
  type ApiErrorResponse,
  type ApiResponse,
} from '..';
import type { CrsType } from '../../enums';
import api from '../api';
import type { CRSInfo, CRSList } from './types';

// APIs.
export const getCRSList = async (crsType?: CrsType[]): Promise<CRSList> => {
  const config = isEmpty(crsType)
    ? undefined
    : { params: { crs_type: crsType!.join(',') } };
  const response = await api.get<CRSList, ApiResponse<CRSList>>('crs/', config);
  return apiDataResponseMapper(response.data);
};

export const getCRSInfo = async (srid: string): Promise<CRSInfo> => {
  const response = await api.get<CRSInfo, ApiResponse<CRSInfo>>(`crs/${srid}/`);
  return apiDataResponseMapper(response.data);
};

// Hooks.
export const useCRSList = (crsType?: CrsType[]) =>
  useQuery<CRSList, ApiErrorResponse>({
    // crsType is part of the key so filtered/unfiltered lists are cached
    // separately and never overwrite each other.
    queryKey: ['CRSList', crsType ?? []],
    queryFn: () => getCRSList(crsType),
  });

export const useCRSInfo = (srid: string, enabled = false) =>
  useQuery<CRSInfo, ApiErrorResponse>({
    queryKey: ['CRSInfo', srid],
    queryFn: () => getCRSInfo(srid),
    enabled,
  });
